<div class="modal-header">
    <h4 class="modal-title">Confirmation</h4>
    <button type="button" class="btn-close" (click)="close()"></button>
  </div>
  <div class="modal-body">
    <p>{{ message }}</p>
  </div>
  <div class="modal-footer">
    <div class="custom-button">
        <button class="btn btn-primary improved-add-btn d-flex align-items-center" (click)="publishProfile()">
          <div>Publish</div>
        </button>
      </div>
  </div>
  